import React from 'react';
import Icons from './Icons';

const FloatingWhatsAppButton = () => {
  // Número real de GesOps: +1 (804) 960-8133
  const whatsappUrl = 'https://wa.me/18049608133?text=Hola%2C+quisiera+m%C3%A1s+informaci%C3%B3n+sobre+los+servicios+de+GesOps';

  return (
    <a
      href={whatsappUrl}
      className="floating-whatsapp-btn"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
    >
      <Icons.WhatsApp />
    </a>
  );
};

export default FloatingWhatsAppButton;
